module.exports = __webpack_public_path__ + "img/3-TWK-Home-Page-MVP.9105579c.png";